import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard, EmailGuard } from "../App";
import { Oval } from "react-loader-spinner";
import { FaArrowLeft } from "react-icons/fa";
import { StandardURL } from "../App";

const UpdateWaterUnitsPage = () => {
  const [newAmount, setNewAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleUpdateWaterUnits = async () => {
    // Basic validation
    if (!newAmount || newAmount <= 0) {
      toast.error("Please enter a valid amount greater than zero.");
      return;
    }

    setIsLoading(true);
    const waterUnitsData = JSON.parse(localStorage.getItem("waterUnits"));

    if (!waterUnitsData || !waterUnitsData.water_unit_id) {
      toast.error("Water unit information not found. Please try again.");
      setIsLoading(false);
      return;
    }

    const waterUnitsId = waterUnitsData.water_unit_id;
    const token = localStorage.getItem("token");

    const requestBody = {
      amount: newAmount,
    };

    try {
      const response = await axios.patch(
        `${StandardURL}/iNyumba/waterunits/updatewaterunits/${waterUnitsId}`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.response);
      navigate(-1);
    } catch (error) {
      console.error("Error updating water units:", error);
      toast.error(error.response?.data?.response || "Failed to update water units.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleNewAmountChange = (e) => {
    setNewAmount(e.target.value);
  };

  return (
    <EmailGuard>
      <AuthGuard>
        <div className="container mx-auto px-4 py-8 bg-gray-100 min-h-screen">
          <div className="flex items-center mb-6">
            <button
              onClick={() => navigate(-1)}
              className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded-md transition duration-150 ease-in-out"
              disabled={isLoading}
            >
              <FaArrowLeft />
            </button>
            <h1 className="text-3xl font-bold text-gray-800 ml-4">Update Water Units</h1>
          </div>

          <div className="bg-white p-8 rounded-lg shadow-lg max-w-md mx-auto">
            <div className="mb-6">
              <label htmlFor="newAmount" className="block text-gray-700 font-semibold mb-2">
                New Amount (Ksh):
              </label>
              <input
                type="number"
                id="newAmount"
                className="w-full border-gray-300 rounded-md py-3 px-4 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
                placeholder="Enter new amount"
                value={newAmount}
                onChange={handleNewAmountChange}
                disabled={isLoading}
              />
            </div>

            <button
              onClick={handleUpdateWaterUnits}
              disabled={isLoading}
              className={`w-full py-3 px-6 rounded-md font-semibold transition duration-150 ease-in-out
                ${isLoading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700 text-white"
                }`}
            >
              {isLoading ? (
                <div className="flex justify-center items-center">
                  <Oval height={24} width={24} color="white" secondaryColor="white" visible={true} ariaLabel="loading-indicator" />
                  <span className="ml-2">Updating...</span>
                </div>
              ) : (
                "Update Water Units"
              )}
            </button>
          </div>
        </div>
      </AuthGuard>
    </EmailGuard>
  );
};

export default UpdateWaterUnitsPage;